import { render } from "./VerticalFeed.vue?vue&type=template&id=a9492742"
import script from "./VerticalFeed.vue?vue&type=script&lang=js"
export * from "./VerticalFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__